/* eslint-disable import/prefer-default-export */
import React from 'react';

export type AddBankDetailsContextType = {
  accountNameErrorMessage?: string;
  accountTypeErrorMessage?: string;
  action?: string;
  allowContinue?: string;
  correctName?: string;
  displayAccountNameCloseMatchMessage?: boolean;
  displayAccountNameErrorMessage?: boolean;
  displayAccountTypeErrorMessage?: boolean;
  displayName?: string;
  index?: number;
  message?: string;
  providedName?: string;
}

export const AddBankDetailsContext = React.createContext({});
AddBankDetailsContext.displayName = 'AddBankDetailsContext';
